export default __webpack_public_path__ + "static/media/cal-donuts.f0cbabe6.png";